<template>
  <div class="gallery_container">
    <modal v-if="modalEnabled" />
    <navigation/>
    <div class="wrapper">
      <h3>Wybierz kategorię, która Cie interesuje</h3>
   <div class="categories">
     <router-link class="single-category" tag="div" :to="`gallery${category.to}`" v-for="category in categories" :key="category.id">
       <div class="icon" :style="`background-image: url('${category.image}'); background-position: center; background-size: cover;`"></div>
       <h3 class="category_name">{{category.name}}</h3>
     </router-link>
   </div>
   </div>
   <div class="center">
      <router-link tag="button" class="backBtn" to="/">Wróć</router-link>
      </div>
   <Footer :class="{bottom: $mq === 'large'}"/>
  </div>
</template>

<script>
import modal from '@/components/modal.vue';
import navigation from '../components/navigation.vue';
import Footer from '@/components/Footer.vue';
import { mapState, mapMutations, mapActions } from 'vuex';
export default {
  components:{
    navigation, 
    modal,
    Footer
  },
  computed:{
    ...mapState({
      categories: state=>state.compress.categories,
      modalEnabled: state=>state.realisations.imageState
    })
  },
  methods:{
    ...mapMutations(['bindGalleryCategories']),
    ...mapActions(['showImage'])
  },
  mounted(){
    if(this.categories.length === 0){
      this.bindGalleryCategories();
    }
  }
}
</script>

<style scoped lang="scss">
.backBtn{
  color: white;
  background: black;
  border: none;
  padding: 12px 24px;
  margin: 24px 0;
  cursor: pointer;
}
.center{
  display: flex;
  justify-content: center;
  align-items: center;
}
.bottom{
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
}
.footer_container{
  width: 100%;
}
.wrapper{
  margin-top: 120px;
  padding: 0 34px;
}
.category_name{
  font-size: 13px;
}
.icon{
  width: 130px;
  height: 130px;
}
.single-category{
  margin: 0 4px;
  cursor: pointer;
}
.categories{
  margin: 38px 0;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
.grid-item{
  width: 100%;
  margin: 3px;
  img{
    width: 100%;
  }
}
.grid_container{
  padding-top: 100px;
}

@media (min-width: 1440px){
  .grid_container{
    margin-top: 120px;
    padding: 0 100px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: row;
    flex-wrap: wrap;
    width: 100%;
  }
  .grid-item{
    width: 400px;
    height: 400px;
    cursor: pointer;
  }
}


</style>